/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowtodescription3Inputs */

const en_aiflowtodescription3 = /** @type {(inputs: Aiflowtodescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On to the description`)
};

const de_aiflowtodescription3 = /** @type {(inputs: Aiflowtodescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weiter zur Beschreibung`)
};

/**
* | output |
* | --- |
* | "On to the description" |
*
* @param {Aiflowtodescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowtodescription3 = /** @type {((inputs?: Aiflowtodescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowtodescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowtodescription3(inputs)
	return de_aiflowtodescription3(inputs)
});
export { aiflowtodescription3 as "aiFlowToDescription" }